module.exports = __webpack_public_path__ + "static/media/farm_pharm_1.88557d31.jpg";